import {
  SpacesManagementThunk,
  SPACES_MANAGEMENT_SET_SPACES,
  spacesManagementSetSpacesActionType,
  spacesManagementSetSpacesByCompanyActionType,
  SPACES_MANAGEMENT_SET_SPACES_BY_COMPANY,
} from './spacesManagementActionTypes';
import { SpacesManagementSpace } from './spacesManagementTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import SpacesManagementApi from '../../API/space-management/SpacesManagement.api';

export function spaceManagementSetSpacesAction(
  space: SpacesManagementSpace[]
): spacesManagementSetSpacesActionType {
  return {
    type: SPACES_MANAGEMENT_SET_SPACES,
    payload: space,
  };
}

export function spaceManagementSetSpacesByCompanyIdAction(
  space: SpacesManagementSpace[]
): spacesManagementSetSpacesByCompanyActionType {
  return {
    type: SPACES_MANAGEMENT_SET_SPACES_BY_COMPANY,
    payload: space,
  };
}

export function spacesManagementFetchSpacesThunk(): SpacesManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    SpacesManagementApi.getSpaces()
      .then((response) => {
        dispatch(spaceManagementSetSpacesAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function spacesManagementFetchSpacesMyCompanyThunk(): SpacesManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    SpacesManagementApi.getCompanySpaces()
      .then((response) => {
        dispatch(spaceManagementSetSpacesByCompanyIdAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}
